import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("p", { class: "text-red-lp-100 text-14px font-semibold cursor-pointer" }, " Lihat Lebih Sedikit ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!

  return (_ctx.version === 'v1')
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: "flex flex-row justify-end",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.unExpandProduct && _ctx.unExpandProduct(...args)))
      }, [
        _createVNode(_component_Icons, {
          name: "chevron-left",
          class: "text-red-lp-100 cursor-pointer w-5 h-5"
        }),
        _hoisted_1
      ]))
    : _createCommentVNode("", true)
}